module.exports = __webpack_public_path__ + "static/media/gender.b9eb5304.svg";